export default interface IInitiativeSubmissionQuestions {
  id: number
  text: string
  answerRules: {
    maxLength: number
  }
  questionType: QuestionType
  order: number
  answer: string
  options: {
    id: number
    text: string
  }[]
  choices: number[]
}

export enum QuestionType {
  FREE_TEXT = 'FREE_TEXT',
  MEDIA_LINK = 'MEDIA_LINK',
  CHECKBOX = 'CHECKBOX',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE'
}
